import { render, staticRenderFns } from "./NewHelpModal.vue?vue&type=template&id=ca72f0aa&"
import script from "./NewHelpModal.vue?vue&type=script&lang=js&"
export * from "./NewHelpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports